import React, { useState } from "react";
import "../../styling/Dashboard.css";
import defaultPic from "../../images/defaultPic.svg";

import CancelEventModal from "../modals/CancelEventModal";
import { FaTrash } from "react-icons/fa";

import axios from "axios";
import { EventDataContext } from "../EventDataContext";
import { useEffect, useContext } from "react";

import { FaUserCircle } from "react-icons/fa";

const OverviewRightPanel = ({ brandingColours }) => {
  const { EventData, setEventData } = useContext(EventDataContext);
  const [paymentIntentId, setPaymentIntentId] = useState("");
  const [deductionAmount, setDeductionAmount] = useState("");
  const [refundDetails, setRefundDetails] = useState(null);
  const [error, setError] = useState(null);

  const [chosenPackage, setChosenPackage] = useState(null);
  const [addons, setAddons] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [activeMenuIndex, setActiveMenuIndex] = useState(null);

  const handleRefund = async (event) => {
    event.preventDefault();

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/create-refund`,
        {
          paymentIntentId,
          deductionAmount: parseFloat(deductionAmount),
        }
      );

      setRefundDetails(response.data);
      setError(null);
    } catch (err) {
      setError(err.response ? err.response.data.error : "An error occurred");
      setRefundDetails(null);
    }
  };

  useEffect(() => {
    if (EventData?.packageId) {
      fetchPackage();
    }

    if (EventData?.addonIds) {
      fetchAddons();
    }
  }, [EventData]);

  const fetchPackage = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/business/getPackageDetail/${EventData.packageId}`,
        { withCredentials: true }
      );


      setChosenPackage(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAddons = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/business/getAddonDetail/${EventData._id}`,
        { withCredentials: true }
      );

      setAddons(response.data.addons);
    } catch (error) {
      console.log(error);
    }
  };

  const addonCost = addons?.reduce((sum, item) => sum + (item.cost || 0), 0);

  const [members, setMembers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  // --- New Handler ---
const handleUnassignMember = async (memberId) => {
  try {
    await axios.post(
      `${process.env.REACT_APP_API_URL}/event/removeTeamMember`,
      {
        eventId: EventData._id,
        teamMemberIds: [memberId], // Sending as array to match your "add" logic style
      },
      { withCredentials: true }
    );
    alert("Member unassigned successfully!");
    fetchTeamMembers(); // Refresh the list
    setActiveMenuIndex(null); // Close menu
  } catch (error) {
    console.error("Failed to unassign member", error);
  }
};

  const fetchTeamMembers = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/event/teamMembers/${EventData._id}`,
        { withCredentials: true }
      );

      setMembers(res.data.teamMembers); // Assuming response is { members: [...] }
    } catch (error) {
      console.error("Failed to fetch team members", error);
    }
  };

  useEffect(() => {
    fetchTeamMembers();
  }, []);

  useEffect(() => {
    const fetchAllUsers = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/business-user/teamMembers`,
          { withCredentials: true }
        );
        setAllUsers(res.data.data.teamMembers);
      } catch (error) {
        console.error("Failed to fetch all users", error);
      }
    };

    fetchAllUsers();
  }, []);

  const handleSelectChange = (e) => {
    const userId = e.target.value;
    if (e.target.checked) {
      // Add user ID to selected list
      setSelectedUserIds((prevIds) => [...prevIds, userId]);
    } else {
      // Remove user ID from selected list
      setSelectedUserIds((prevIds) => prevIds.filter((id) => id !== userId));
    }
  };

  // Handle adding a new team member to the event
  const handleAddMember = async () => {
    if (!selectedUserIds) return;
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/event/addTeamMember`,
        {
          eventId: EventData._id,
          teamMemberIds: selectedUserIds,
        },
        { withCredentials: true }
      );

      alert("Team members added successfully!");

      fetchTeamMembers();
      setShowDropdown(false); // Hide dropdown after adding
      setSelectedUserIds(""); // Reset dropdown
    } catch (error) {
      console.error("Failed to add member", error);
    }
  };

  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

  const openCancelModal = () => setIsCancelModalOpen(true);
  const closeCancelModal = () => setIsCancelModalOpen(false);

  return (
    <div
      className="right-panel-business-overview"
      style={{ marginTop: "0px", width: "20%", height: "auto", paddingTop: '0px', borderLeft: "none", padding: "0px" }}
    >
      <div>
      <div className="right-panel-content-business-overview" style={{marginTop: "0px"}}>
          <div className="event-total-div">
            
            {/* Added the mobile event name block from the client tab (using real data) */}
            <div className="overview-event-name">
              <h2 style={{marginBottom: '0px', marginTop: '0px'}}>{EventData?.eventName}</h2>
              <span style={{ color: '#625C73', }}>
              Date Booked: {EventData?.eventDate ? new Date(EventData.eventDate).toLocaleDateString() : ""}
              </span>
            </div>

            {/* Exactly matches the client tab's flexbox layout */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
              className="event-total-box"
            >
              <div>
                <h4
                  style={{
                    color: "#000000",
                    marginTop: "0px",
                    marginBottom: "5px",
                    fontWeight: "400",
                  }}
                >
                  Event Total:
                </h4>
                <h1
                  style={{
                    color: "#000000",
                    marginBottom: "20px",
                    marginTop: "5px",
                  }}
                >
                 $ {EventData?.expPaymentAmount}
                </h1>
              </div>
              <div
                style={{
                  backgroundColor: EventData.payment === 'paid' ? '#E1FAE3' : '#FDDCDC',
                  color: EventData.payment === 'paid' ? '#21A62C' : '#FF0000',
                  padding: "5px 10px", // Adjusted padding to center the text nicely
                  height: "20px",
                  alignSelf: "initial",
                  borderRadius: "5px", // Added border-radius so the badge looks clean
                  display: "flex",
                  alignItems: "center"
                }}
              >
                {EventData.payment === 'paid' ? 'Paid' : 'Pending'}
              </div>
            </div>

          <button
            style={{
              width: "100%",
              height: "35px",
              marginLeft: "1%",
              marginBottom: "3%",

              color: brandingColours?.secondaryColor || "#FFFFFF",
              fontWeight: "400",
              fontSize: "15px",
              background: brandingColours?.primaryColor || "#231081",
              borderRadius: "5px",
              border: "1px solid #D9D9D9",
              cursor: "pointer",
            }}
            // className="events-button-hover-underline"
            onClick={openCancelModal} // ✅ Attach handler
          >
            Cancel
          </button>
          <CancelEventModal
            isOpen={isCancelModalOpen}
            closeModal={closeCancelModal}
            eventData={EventData}
            addons={addons}
            chosenPackage={chosenPackage}
          />
        </div>
      </div>
        <div
          className="right-panel-content-business-overview"
          style={{ marginTop: "0px", borderTop: "hidden" }}
        >
          <div className="right-panel-arrow-container">
            <span>
              <h4
                style={{
                  color: "#000000",
                  marginTop: "0px",
                  marginBottom: "5px",
                  fontWeight: "400",
                }}
              >
                {chosenPackage?.name}
              </h4>
            </span>{" "}
            <div
              style={{
                alignSelf: "flex-end",
                fontSize: "15px",
                marginRight: "10px",
                marginBottom: "5px",
                color: "#0000004",
                fontWeight: "400",
              }}
            >
              $ {chosenPackage?.cost}
            </div>
          </div>

          <div style={{ color: "#625C73", whiteSpace: "pre-wrap" }}>
            <p style={{ marginBottom: "3px" }}>{chosenPackage?.description}</p>
          </div>
        </div>

        <div
          className="right-panel-content-business-overview"
          style={{ marginTop: "0px", borderTop: "hidden" }}
        >
          <div className="right-panel-arrow-container">
            <span>
              <h4
                style={{
                  color: "#000000",
                  marginTop: "0px",
                  marginBottom: "5px",
                  fontWeight: "400",
                }}
              >
                Add Ons
              </h4>
            </span>{" "}
            <div
              style={{
                alignSelf: "flex-end",
                fontSize: "15px",
                marginRight: "10px",
                marginBottom: "5px",
                color: "#0000004",
                fontWeight: "400",
              }}
            >
              $ {addonCost?.toFixed(2) || '0.00'}
            </div>
          </div>

          {addons?.map((item, index) => (
            <div style={{ color: "#625C73", whiteSpace: "pre-wrap" }} key={index}>
              <p>{item.name}</p>
            </div>
          ))}
        </div>
      </div>
      <div
        className="members-panel"
        style={{
          width: "100%",
          marginTop: "0px",
          padding: "16px",
          backgroundColor: "#fff",
          borderBottom: "1px solid #ddd"
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <h3
            style={{
              fontWeight: "500",
              color: "#000000",
              margin: "0",
              fontSize: "18px",
            }}
          >
            Assigned Team Members
          </h3>
        </div>

        {/* Members List */}
<div style={{ marginTop: "12px" }}>
  {Array.isArray(members) && members.length > 0 ? (
    members.map((member, index) => (
      <div
        key={index}
        onMouseEnter={() => setHoveredIndex(index)}
        onMouseLeave={() => {
          setHoveredIndex(null);
          setActiveMenuIndex(null); // Optional: close menu when mouse leaves row
        }}
        style={{
          display: "flex",
          alignItems: "center",
          padding: "10px 8px",
          borderBottom: "1px solid #f0f0f0",
          backgroundColor: hoveredIndex === index ? "#F9F9FB" : "transparent",
          borderRadius: "8px",
          position: "relative", // For absolute positioning of dots
          transition: "background-color 0.2s ease",
        }}
      >
        <div
          style={{
            borderRadius: "50%",
            overflow: "hidden",
            marginRight: "12px",
            width: "45px",
            height: "45px",
            flexShrink: 0,
            border: "1px solid #e0e0e0",
          }}
        >
            <img
              src={member.profilePic || defaultPic}
              alt="Profile"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
        </div>
        <div style={{ flex: 1 }}>
          <h4 style={{ margin: 0, fontWeight: "500", color: "#000", fontSize: "15px" }}>
            {member.firstName} {member.lastName}
          </h4>
          <p style={{ margin: 0, color: "#625C73", fontSize: "13px" }}>
            {member.designation || "Booth Attendant"}
          </p>
        </div>

        {/* Three Dots Menu - Only visible on hover */}
        {hoveredIndex === index && (
          <div style={{ position: "relative" }}>
            <div
              onClick={() => setActiveMenuIndex(activeMenuIndex === index ? null : index)}
              style={{
                cursor: "pointer",
                padding: "4px",
                fontSize: "20px",
                color: "#625C73",
              }}
            >
              ⋮
            </div>

            {/* Unassign Dropdown */}
             {/* Unassign Dropdown */}
{activeMenuIndex === index && (
  <div
    style={{
      position: "absolute",
      right: "0",
      top: "30px",
      backgroundColor: "#ffffff",
      boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
      borderRadius: "4px",
      zIndex: 100,
      minWidth: "110px",
      border: "1px solid #e0e0e0",
      overflow: "hidden"
    }}
  >
    <button
      onClick={(e) => {
        e.stopPropagation();
        handleUnassignMember(member._id);
      }}
      style={{
        width: "100%",
        textAlign: "left",
        padding: "8px 12px",
        // FORCING WHITE BACKGROUND HERE
        backgroundColor: "#ffffff", 
        background: "#ffffff", 
        border: "none",
        color: "#625C73",
        cursor: "pointer",
        fontSize: "13px",
        fontWeight: "400",
        display: "flex",
        alignItems: "center",
        gap: "8px",
      }}
      // onMouseEnter={(e) => {
      //   e.currentTarget.style.backgroundColor = "#f5f5f5";
      //   e.currentTarget.style.color = "#000000";
      // }}
      // onMouseLeave={(e) => {
      //   e.currentTarget.style.backgroundColor = "#ffffff";
      //   e.currentTarget.style.color = "#625C73";
      // }}
    >
      <FaTrash size={12} style={{ color: "#625C73" }} /> 
      Unassign
    </button>
  </div>
)}
          </div>
        )}
      </div>
    ))
  ) : (
    <p style={{ color: "#888", marginTop: "8px" }}>No team members assigned.</p>
  )}
</div>

        {/* Add Button or Dropdown */}
        <div style={{ marginTop: "20px", width: "100%" }}>
          {!showDropdown ? (
            <button
              onClick={() => setShowDropdown(true)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                backgroundColor: "transparent",
                borderRadius: "5px",
                padding: "6px 16px",
                fontWeight: "500",
                cursor: "pointer",
                transition: "all 0.3s ease",
                border: "none",
                fontSize: "15px",
                color: "#4D4D4D"
              }}
            >
              <span
                style={{
                  borderRadius: "50%",
                  border: "1px solid #fff",
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "20px",
                  lineHeight: "1", // ensures the '+' is perfectly centered vertically
                  boxSizing: "border-box",
                  color: "#4D4D4D"
                }}
              >
                +
              </span>
              Add Team Member
            </button>
          ) : (
            <div style={{ marginTop: "12px", width: "100%" }}>
              {/* Custom styled user list as options */}
              <div
                style={{
                  border: "1px solid #D9D9D9",
                  borderRadius: "6px",
                  padding: "8px",
                  backgroundColor: "#f9f9f9",
                  maxHeight: "300px",
                  overflowY: "auto",
                  color: "#4D4D4D"
                }}
              >
                {Array.isArray(allUsers) && allUsers.length > 0 ? (
                  allUsers.map((user) => {
                    const isSelected = selectedUserIds.includes(user._id);

                    return (
                      <label
                        key={user._id}
                        onClick={() => {
                          if (isSelected) {
                            // Remove from selection
                            setSelectedUserIds(
                              selectedUserIds.filter((id) => id !== user._id)
                            );
                          } else {
                            // Add to selection
                            setSelectedUserIds([...selectedUserIds, user._id]);
                          }
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "8px",
                          marginBottom: "6px",
                          backgroundColor: "#fff",
                          border: isSelected
                            ? "2px solid blue"
                            : "1px solid #e0e0e0",
                          borderRadius: "6px",
                          cursor: "pointer",
                          userSelect: "none",
                          transition: "border 0.3s",
                        }}
                      >
                        <div
                          style={{
                            borderRadius: "50%",
                            overflow: "hidden",
                            marginRight: "12px",
                            width: "40px",
                            height: "40px",
                            flexShrink: 0,
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          <img
                            src={user.photoUrl || defaultPic}
                            alt="Profile"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "50%",
                            }}
                          />
                        </div>
                        <div>
                          <p
                            style={{
                              margin: 0,
                              fontWeight: "500",
                              color: "#000",
                            }}
                          >
                            {user.firstName + " " + user.lastName}
                          </p>
                        </div>
                      </label>
                    );
                  })
                ) : (
                  <p style={{ color: "#888" }}>Loading team members...</p>
                )}
              </div>

              {/* Add button below */}
              <button
                onClick={handleAddMember}
                style={{
                  marginTop: "14px",
                  width: "100%",
                  padding: "10px",
                  backgroundColor: "white",
                  border: "none",
                  borderRadius: "6px",
                  fontWeight: "500",
                  cursor: "pointer",
                  border: "1px solid #D9D9D9",
                  fontSize: "15px",
                  color: "#4D4D4D"
                }}
              >
                Add Selected Members
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OverviewRightPanel;
